// Copyright (c) 2022 by Move Closer

import { computed } from '@vue/composition-api'
import { VueConstructor } from 'vue'

import { ComponentObjectPropsOptions } from '../../vue-api'
import { CustomDSLConfiguration, getDSLConfig } from '../../contracts'

import { IconProps, UseCustomIconProvides } from './Icon.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const customIconProps: ComponentObjectPropsOptions<IconProps> = {
  color: {
    type: String,
    required: false,
    default: 'none'
  },

  height: {
    type: [Number, String],
    required: false,
    default: '1em'
  },

  name: {
    type: String,
    required: false
  },

  width: {
    type: [Number, String],
    required: false,
    default: '1em'
  }
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const useCustomIcon = (props: IconProps): UseCustomIconProvides => {
  const dslConfig = getDSLConfig<CustomDSLConfiguration>()

  /**
   * @see UseCustomIconProvides.component
   */
  const component: UseCustomIconProvides['component'] = computed<VueConstructor | undefined>(() => {
    // Uncomment below line to see result in stories
    // return IconExample

    if (typeof dslConfig === 'undefined' || typeof dslConfig.icons === 'undefined') {
      return undefined
    }
    //
    return dslConfig.icons[props.name]
  })

  return { component }
}
